var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGodLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79515 18.8525C7.56628 18.8525 6.41642 18.5993 5.34555 18.0931C4.27469 17.5869 3.33548 16.8887 2.52795 15.9984C1.73796 15.1082 1.11475 14.0957 0.658319 12.9611C0.21944 11.8264 0 10.622 0 9.34768C0 8.07339 0.21944 6.87766 0.658319 5.76047C1.11475 4.64329 1.73796 3.6483 2.52795 2.7755C3.33548 1.9027 4.27469 1.22192 5.34555 0.733151C6.43398 0.244384 7.61895 0 8.90048 0C10.6736 0 12.1657 0.375303 13.3771 1.12591C14.6059 1.85906 15.5276 2.8366 16.142 4.05852L13.8774 5.68192C13.3858 4.66947 12.6836 3.91014 11.7708 3.40392C10.8754 2.89769 9.89235 2.64458 8.82148 2.64458C7.94372 2.64458 7.14496 2.82787 6.4252 3.19444C5.70544 3.56102 5.08223 4.06724 4.55557 4.71311C4.04647 5.34153 3.66026 6.06595 3.39693 6.88638C3.1336 7.68936 3.00194 8.53597 3.00194 9.42623C3.00194 10.3689 3.15116 11.2504 3.44959 12.0708C3.74803 12.8912 4.16936 13.6157 4.71357 14.2441C5.25778 14.855 5.89854 15.3351 6.63586 15.6842C7.37318 16.0333 8.17194 16.2079 9.03214 16.2079C10.0503 16.2079 11.0159 15.9548 11.9287 15.4485C12.8592 14.9249 13.7282 14.1481 14.5357 13.1182V16.1031C12.9031 17.936 10.9895 18.8525 8.79515 18.8525ZM14.246 11.4948H8.82148V9.32149H14.5357L14.3579 11.1937L14.5902 13.8115L15.8607 17.1721L16.7213 18.7215L15.082 17.7869L14.246 11.4948Z",
    fill: "#26272C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.426 18.6887L24.9998 16.3116L26.2703 11.5165L24.426 8.0739L24.426 0.164062H30.9889C32.9855 0.164062 34.6523 0.581518 35.9892 1.41643C37.326 2.23395 38.3244 3.34716 38.9841 4.75607C39.6612 6.14759 39.9998 7.69566 39.9998 9.40027C39.9998 11.2788 39.6265 12.9139 38.8799 14.3054C38.1507 15.6969 37.109 16.7753 35.7548 17.5407C34.4005 18.306 32.8119 18.6887 30.9889 18.6887H24.426ZM37.0309 9.40027C37.0309 8.09572 36.7878 6.94772 36.3017 5.95626C35.8329 4.94741 35.1471 4.16468 34.2443 3.60807C33.3588 3.03407 32.2737 2.74707 30.9889 2.74707H27.3429V16.1056H30.9889C32.291 16.1056 33.3848 15.81 34.2703 15.2186C35.1731 14.6272 35.8589 13.827 36.3277 12.8182C36.7965 11.8093 37.0309 10.67 37.0309 9.40027Z",
    fill: "#26272C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_580_364)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9592 20.3279C23.9203 20.3279 27.1314 17.1168 27.1314 13.1558C27.1314 9.19471 23.9203 5.98364 19.9592 5.98364C15.9982 5.98364 12.7871 9.19471 12.7871 13.1558C12.7871 17.1168 15.9982 20.3279 19.9592 20.3279ZM19.9789 17.9398C23.0051 17.9398 25.4584 15.4866 25.4584 12.4603C25.4584 9.43402 23.0051 6.98075 19.9789 6.98075C16.9526 6.98075 14.4993 9.43402 14.4993 12.4603C14.4993 15.4866 16.9526 17.9398 19.9789 17.9398Z",
    fill: "url(#paint0_linear_580_364)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_580_364",
    x: 6.78711,
    y: 0.983643,
    width: 26.3442,
    height: 26.3442,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_580_364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_580_364",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_580_364",
    x1: 20.0002,
    y1: 4.26233,
    x2: 20.0002,
    y2: 21.9263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26C0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F35CE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGodLogo);
export default __webpack_public_path__ + "static/media/god_logo.c70a41cacace8a5a24b448aee6a0c3a2.svg";
export { ForwardRef as ReactComponent };